import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: () => import('@/views/MainPage'),
            props: route => ({ viewoption: route.query.v, accesscode: route.query.a, username: route.query.u, })
            // use props as  fabtools.mit.edu/iap?v=cancel&a=[accesscode]
        },        
        {
            path: '/done',
            component: () => import('@/views/SummaryPage')
        }        
    ],
});

export default router;